export const TRANSFER_OF_INTEREST_LOADING = 'TRANSFER_OF_INTEREST_LOADING';
export const TRANSFER_OF_INTEREST_SUCCESS = 'TRANSFER_OF_INTEREST_SUCCESS';
export const TRANSFER_OF_INTEREST_ERROR = 'TRANSFER_OF_INTEREST_ERROR';
export const TRANSFER_OF_INTEREST_CLEAR_ERROR = 'TRANSFER_OF_INTEREST_CLEAR_ERROR';
export const TRANSFER_OF_INTEREST_CLEAR_APPLICATION = 'TRANSFER_OF_INTEREST_CLEAR_APPLICATION';

export const TRANSFER_OF_INTEREST_FETCH_PROPERTY_DETAILS_SUCCESS =
  'TRANSFER_OF_INTEREST_FETCH_PROPERTY_DETAILS_SUCCESS';

export const TRANSFER_OF_INTEREST_FETCH_APPLICATION_DETAILS_SUCCESS =
  'TRANSFER_OF_INTEREST_FETCH_APPLICATION_DETAILS_SUCCESS';

export const TRANSFER_OF_INTEREST_SET_CONTRACT_DETAILS = 'TRANSFER_OF_INTEREST_SET_CONTRACT_DETAILS';

export const TRANSFER_OF_INTEREST_SET_MORTGAGE_BANK_MAKER_DETAILS =
  'TRANSFER_OF_INTEREST_SET_MORTGAGE_BANK_MAKER_DETAILS';
export const TRANSFER_OF_INTEREST_DELETE_BROKER_SUCCESS = 'TRANSFER_OF_INTEREST_DELETE_BROKER_SUCCESS';

export const TRANSFER_OF_INTEREST_ADD_BUYER_SUCCESS = 'TRANSFER_OF_INTEREST_ADD_BUYER_SUCCESS';

export const TRANSFER_OF_INTEREST_SET_BUYER_TRANSACTION_PERCENTAGE =
  'TRANSFER_OF_INTEREST_SET_BUYER_TRANSACTION_PERCENTAGE';

export const TRANSFER_OF_INTEREST_CHANGE_WORKFLOW_STEP = 'TRANSFER_OF_INTEREST_CHANGE_WORKFLOW_STEP';

export const TRANSFER_OF_INTEREST_SAVE_APPLICATION_SUCCESS = 'TRANSFER_OF_INTEREST_SAVE_APPLICATION_SUCCESS';

export const TRANSFER_OF_INTEREST_FETCH_DOCUMENTS_SUCCESS = 'TRANSFER_OF_INTEREST_FETCH_DOCUMENTS_SUCCESS';
export const TRANSFER_OF_INTEREST_FETCH_BREAKDOWN_SUCCESS = 'TRANSFER_OF_INTEREST_FETCH_BREAKDOWN_SUCCESS';
export const TRANSFER_OF_INTEREST_RESET_BREAKDOWN_SUCCESS = 'TRANSFER_OF_INTEREST_RESET_BREAKDOWN_SUCCESS';

export const TRANSFER_OF_INTEREST_FIELD_CHANGE = 'TRANSFER_OF_INTEREST_FIELD_CHANGE';
export const TRANSFER_OF_INTEREST_FORM_ERROR = 'TRANSFER_OF_INTEREST_FORM_ERROR';

export const TRANSFER_OF_INTEREST_FETCH_GOVERNMENT_COMPANIES_SUCCESS =
  'TRANSFER_OF_INTEREST_FETCH_GOVERNMENT_COMPANIES_SUCCESS';

export const TRANSFER_OF_INTEREST_CLEAR_GOVERNMENT_COMPANIES = 'TRANSFER_OF_INTEREST_CLEAR_GOVERNMENT_COMPANIES';

export const TRANSFER_OF_INTEREST_FETCH_NON_UAE_USERS = 'TRANSFER_OF_INTEREST_FETCH_NON_UAE_USERS';
export const TRANSFER_OF_INTEREST_FETCH_NON_UAE_USERS_SUCCESS = 'TRANSFER_OF_INTEREST_FETCH_NON_UAE_USERS_SUCCESS';

export const UPDATE_SALE_DETAILS = 'UPDATE_SALE_DETAILS';

export const TRANSFER_OF_INTEREST_CLEAR_REDUCER = 'TRANSFER_OF_INTEREST_CLEAR_REDUCER';

export const SET_IS_SHARED_MORTGAGE = 'SET_IS_SHARED_MORTGAGE';
export const SET_MORTGAGE_SHARES = 'SET_MORTGAGE_SHARES';
export const RESET_MORTGAGE_SHARES = 'RESET_MORTGAGE_SHARES';

export const SET_IS_SHARED_SELLING = 'SET_IS_SHARED_SELLING';
export const SET_SELLING_SHARES = 'SET_SELLING_SHARES';
export const RESET_SELLING_SHARES = 'RESET_SELLING_SHARES';

export const SHOW_VALIDATION_MESSAGE = 'SHOW_VALIDATION_MESSAGE';

export const FETCH_VALUATORS = 'FETCH_VALUATORS';
export const FETCH_VALUATORS_SUCCESS = 'FETCH_VALUATORS_SUCCESS';
export const FETCH_VALUATORS_ERROR = 'FETCH_VALUATORS_ERROR';
export const SET_SELECTED_PRIMARY_BUYER_ID = 'SET_SELECTED_PRIMARY_BUYER_ID';

export const FETCH_ACTIVE_AGREEMENTS = 'FETCH_ACTIVE_AGREEMENTS';
export const FETCH_ACTIVE_AGREEMENTS_SUCCESS = 'FETCH_ACTIVE_AGREEMENTS_SUCCESS';
export const FETCH_ACTIVE_AGREEMENTS_ERROR = 'FETCH_ACTIVE_AGREEMENTS_ERROR';

export const SET_ATTENDANCE_TYPE = 'SET_ATTENDANCE_TYPE';
